import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment.development';

@Injectable({ providedIn: 'root' })
export class AppBetaStateService {
  private betaActiveSubject = new BehaviorSubject<boolean>(environment.betaDefaultValue);
  betaActive$ = this.betaActiveSubject.asObservable();

  setBetaActive(value: boolean) {
    this.betaActiveSubject.next(value);
  }

  get betaActive(): boolean {
    return this.betaActiveSubject.value;
  }
}